import { Route } from '@angular/router';
import { authGuard } from '../../guards/auth-guard/auth-guard';

export const guardianAgreementRoute: Route = {
  path: 'guardian-agreement',
  loadChildren: () => import('../../../components/guardian-agreement/guardian-agreement.module').then(m => m.GuardianAgreementModule),
  canActivate: [authGuard],
};
